import RequesterV1 from "@/components/api/v1/requester.js";

const BASE_PATH =
  "agro_exporter/quality_reports/process/show_process";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${agro_exporter_id}/agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchRejectedPercentage(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${agro_exporter_id}/rejected_percentage_weekly/${agro_exporter_process_id}`
    );
  },

  fetchTopDefects(
    agro_exporter_id,
    agro_exporter_process_id,
    provider_id = null
  ) {
    const basePath = `${BASE_PATH}/${agro_exporter_id}/top_defects/${agro_exporter_process_id}`;
    const path = provider_id ? `${basePath}/${provider_id}` : basePath;
    return RequesterV1.get(path);
  },

  fetchSummary(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${agro_exporter_id}/summary/${agro_exporter_process_id}`
    );
  },

  fetchIndicators(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${agro_exporter_id}/indicators/${agro_exporter_process_id}`
    );
  },

  fetchProvidersEfficiency(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${agro_exporter_id}/providers_efficiency/${agro_exporter_process_id}`
    );
  },

  fetchProvidersByInspector(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${agro_exporter_id}/providers_by_inspector/${agro_exporter_process_id}`
    );
  },
  fetchProvidersRejectedAttributeCategory(
    agro_exporter_id,
    agro_exporter_process_id
  ) {
    return RequesterV1.get(
      `${BASE_PATH}/${agro_exporter_id}/providers_rejected_attribute_category/${agro_exporter_process_id}`
    );
  },

  fetchQuarterlyReport(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `${BASE_PATH}/${agro_exporter_id}/quarterly_report/${agro_exporter_process_id}`
    );
  }
};
